import { render, staticRenderFns } from "./ProgrammeDetails.vue?vue&type=template&id=2053c70f&scoped=true&"
import script from "./ProgrammeDetails.vue?vue&type=script&lang=js&"
export * from "./ProgrammeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeDetails.vue?vue&type=style&index=0&id=2053c70f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053c70f",
  null
  
)

export default component.exports